import {bp} from '../core/namespace.js';

$.extend(true, bp, {
  lightbox: (function () {
    // Restored from the pre-refactor components/bp-lightbox.js (Akinshola's
    // BPCOM-1638 gallery work). The BPCOM-1566 bundle refactor branch was cut
    // before that work and shipped a stripped-down lightbox, dropping: the
    // iLightBox thumbnail strip (controls.thumbnail), the CTA lead-slide built
    // from the first photo, the custom chrome (topbar/title/counter/close) and
    // the arrow alignment. The matching CSS (.bp-ilightbox-*) survived on
    // master, so this JS is all that was needed to bring the gallery back.

    function galleryHasLeadSlide(items) {
      var list = items || [];
      for (var i = 0; i < list.length; i += 1) {
        var item = list[i];
        if (item && item.options && item.options.isLeadSlide) {
          return true;
        }
      }
      return false;
    }

    function appendLeadSlide(items) {
      var galleryItems = $.extend(true, [], items || []);
      if (!galleryItems.length || galleryHasLeadSlide(galleryItems)) {
        return galleryItems;
      }

      var firstImage = null;
      for (var i = 0; i < galleryItems.length; i += 1) {
        var item = galleryItems[i];
        if (item && item.type === 'image' && item.URL) {
          firstImage = item;
          break;
        }
      }
      if (!firstImage || !firstImage.URL) {
        return galleryItems;
      }

      var ctaHtml =
        '<div class="bp-ilightbox-cta-slide" style="background-image:url(\'' + firstImage.URL + '\')">' +
          '<div class="bp-ilightbox-cta-slide__scrim"></div>' +
          '<div class="bp-ilightbox-cta-slide__content">' +
            '<h2>Interesse in dit bedrijfspand?</h2>' +
            '<button type="button" class="bp-ilightbox-cta-button">Neem contact op met de aanbieder</button>' +
          '</div>' +
        '</div>';

      galleryItems.push({
        URL: ctaHtml,
        type: 'html',
        options: {
          width: 1440,
          height: 840,
          isLeadSlide: true
        }
      });

      return galleryItems;
    }

    function getVisibleIndex(iL, current) {
      var visibleIndex = 0;
      for (var idx = 0; idx <= current; idx += 1) {
        var item = iL.items[idx];
        if (!(item && item.options && item.options.isLeadSlide)) {
          visibleIndex += 1;
        }
      }
      return visibleIndex;
    }

    function getVisibleTotal(iL) {
      var leadSlides = 0;
      for (var i = 0; i < iL.items.length; i += 1) {
        var item = iL.items[i];
        if (item && item.options && item.options.isLeadSlide) {
          leadSlides += 1;
        }
      }
      return Math.max(iL.items.length - leadSlides, 0);
    }

    function ensureChrome(iL) {
      if (!iL || !iL.vars) return;

      var $body = $('body');
      $body.addClass('bp-ilightbox-open');

      var $overlay = iL.vars.overlay;
      if (!$overlay || !$overlay.length) return;

      if ($overlay.find('.bp-ilightbox-chrome').length) return;

      var meta = window.bpLightboxMeta || {};
      var listingId = meta.listingId ? String(meta.listingId) : '';
      var title = meta.title ? String(meta.title) : '';

      var $chrome = $(
        '<div class="bp-ilightbox-chrome" role="dialog" aria-modal="true">' +
          '<div class="bp-ilightbox-topbar">' +
            '<div class="bp-ilightbox-topbar__meta">' +
              '<div class="bp-ilightbox-topbar__id"></div>' +
              '<h1 class="bp-ilightbox-topbar__title"></h1>' +
            '</div>' +
            '<button type="button" class="bp-ilightbox-close" aria-label="Sluiten">' +
              '<span class="bp-ilightbox-close__label">Sluiten</span>' +
              '<span class="bp-ilightbox-close__icon" aria-hidden="true">×</span>' +
            '</button>' +
          '</div>' +
          '<div class="bp-ilightbox-bottombar">' +
            '<div class="bp-ilightbox-counter" aria-live="polite"></div>' +
          '</div>' +
        '</div>'
      );

      $chrome.find('.bp-ilightbox-topbar__id').text(listingId ? ('Advertentie #' + listingId) : '');
      $chrome.find('.bp-ilightbox-topbar__title').text(title || '');

      $chrome.on('click', '.bp-ilightbox-close', function () {
        if (window.iLightBox && typeof window.iLightBox.close === 'function') {
          window.iLightBox.close();
        }
      });

      $(document)
        .off('click.bpLightboxCta', '.bp-ilightbox-cta-button')
        .on('click.bpLightboxCta', '.bp-ilightbox-cta-button', function () {
          if (window.iLightBox && typeof window.iLightBox.close === 'function') {
            window.iLightBox.close();
          }

          var isMobileViewport = window.matchMedia('(max-width: 1024px)').matches;
          if (isMobileViewport && $('#contact-form-modal').length) {
            $('#contact-form-modal').modal('show');
            return;
          }

          var anchor = document.getElementById('contact_form_anchor');
          if (anchor && typeof anchor.scrollIntoView === 'function') {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });

      $overlay.append($chrome);
    }

    function updateCounter(iL) {
      if (!iL || !iL.vars) return;
      var $overlay = iL.vars.overlay;
      if (!$overlay || !$overlay.length) return;
      var $counter = $overlay.find('.bp-ilightbox-counter');
      if (!$counter.length) return;

      var current = (typeof iL.vars.current === 'number') ? (iL.vars.current + 1) : null;
      var total = getVisibleTotal(iL);
      if (!current || !total) return;

      var currentItem = iL.items[iL.vars.current];
      if (currentItem && currentItem.options && currentItem.options.isLeadSlide) {
        $counter.empty();
        return;
      }

      var visibleCurrent = getVisibleIndex(iL, iL.vars.current);
      if (!visibleCurrent) return;

      $counter.text('Afbeelding ' + visibleCurrent + ' van ' + total);
    }

    function pinArrowsToHolder(iL) {
      if (!iL || !iL.vars || !iL.vars.holder) return;

      var $holder = iL.vars.holder;
      $holder.addClass('bp-ilightbox-holder');

      // Move fixed-position arrows into the holder so they align
      // with the image edges instead of the viewport edges.
      if (iL.vars.prevButton && iL.vars.prevButton.length) $holder.append(iL.vars.prevButton);
      if (iL.vars.nextButton && iL.vars.nextButton.length) $holder.append(iL.vars.nextButton);
    }

    function teardownChrome(iL) {
      $('body').removeClass('bp-ilightbox-open');
      if (iL && iL.vars && iL.vars.overlay) {
        iL.vars.overlay.find('.bp-ilightbox-chrome').remove();
      }
      $(document).off('click.bpLightboxCta');
    }

    function getLightboxOptions(photo_index) {
      return {
        skin: 'dark',
        infinite: true,
        mobileOptimizer: false,
        startFrom: photo_index,
        path: 'horizontal',
        controls: {
          arrows: true,
          toolbar: false,
          fullscreen: false,
          thumbnail: true,
          keyboard: true,
          mousewheel: true,
          swipe: true
        },
        show: {
          effect: true,
          speed: 120,
          title: false
        },
        hide: {
          effect: true,
          speed: 120
        },
        effects: {
          repositionSpeed: 120,
          loadedFadeSpeed: 100,
          slideSpeed: 220
        },
        overlay: {
          blur: false,
          opacity: 0.92
        },
        callback: {
          onOpen: function () {
            ensureChrome(this);
            pinArrowsToHolder(this);
            updateCounter(this);
          },
          onShow: function () {
            ensureChrome(this);
            pinArrowsToHolder(this);
            updateCounter(this);
          },
          onAfterChange: function () {
            ensureChrome(this);
            pinArrowsToHolder(this);
            updateCounter(this);
          },
          onHide: function () {
            teardownChrome(this);
          }
        }
      };
    }

    return {
      open_lightbox: function (event, photo_index) {
        if (event !== undefined && event.type === 'click') {
          var target = event.target ? event.target : event.srcElement;
          if (target.classList.contains('fa-heart') || target.classList.contains('carousel-favourite')) {
            return false;
          }
          var galleryItems = appendLeadSlide(photoslide_items);
          $.iLightBox(galleryItems, getLightboxOptions(photo_index));
        }
      },
      open_lightbox_matterportvideo: function (event, video_index) {
        if (event !== undefined && event.type === 'click') {
          var target = event.target ? event.target : event.srcElement;
          if (target.classList.contains('fa-heart') || target.classList.contains('carousel-favourite')) {
            return false;
          }
          $.iLightBox(matterportslide_items, getLightboxOptions(video_index));
        }
      },
      open_lightbox_unit: function (event, photo_index, unit_num = 0) {
        if (event !== undefined && event.type === 'click') {
          var target = event.target ? event.target : event.srcElement;
          if (target.classList.contains('fa-heart') || target.classList.contains('carousel-favourite')) {
            return false;
          }
          $.iLightBox(unit_photoslide_items[unit_num], getLightboxOptions(photo_index));
        }
      },
    };
  })(),
});

window.bp_lightbox = {box: bp.lightbox};

export {bp};
